import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'
import { Enum } from '../../types/enum';


const GET_DESTINATIONS_QUERY = gql`
query Query {
    getDestinations {
        id
        name
    }
}
`

interface GetDestinationsData {
  getDestinations: Enum[]
}


export const getDestinations = async (): Promise<ApolloQueryResult<GetDestinationsData>> => {
  return await client.query<GetDestinationsData, any>({ query: GET_DESTINATIONS_QUERY })
}
